
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basket",
      function () {
        return require("private-next-pages/basket.tsx");
      }
    ]);
  